import { Moon, Sun } from 'lucide-react';
import { Button } from '../../components/Button/Button';
import { useTheme } from '../themeProvider';

export function ThemeSwitch() {
    const { theme, setTheme } = useTheme();

    return (
        <Button variant="ghost" size="icon" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
            {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
}
